var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIncompleteQuestionItemIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Inconplete_Question_Item_Icon",
    "data-name": "Inconplete Question Item Icon",
    transform: "translate(-1515 -471)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_52",
    "data-name": "Ellipse 52",
    transform: "translate(1515 471)",
    fill: "#fff",
    stroke: "#dceee4",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 12.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "question_mark_24dp_5F6368_FILL0_wght400_GRAD0_opsz24",
    d: "M264.973-831.79a4.612,4.612,0,0,1,.266-1.839,3.726,3.726,0,0,1,1.128-1.224,9.434,9.434,0,0,0,1.147-.987,1.354,1.354,0,0,0,.394-.955,1.347,1.347,0,0,0-.5-1.074,2.109,2.109,0,0,0-1.4-.426,1.919,1.919,0,0,0-1.422.489,3.031,3.031,0,0,0-.688.995l-1.89-.695a3.867,3.867,0,0,1,1.413-1.753A4.305,4.305,0,0,1,266-840a4.311,4.311,0,0,1,2.963.924A2.871,2.871,0,0,1,270-836.858a2.285,2.285,0,0,1-.394,1.35,7.169,7.169,0,0,1-1.239,1.271,4.5,4.5,0,0,0-1.092,1.129,3.209,3.209,0,0,0-.193,1.318ZM266-828a1.536,1.536,0,0,1-1.037-.371,1.139,1.139,0,0,1-.431-.892,1.138,1.138,0,0,1,.431-.892,1.535,1.535,0,0,1,1.037-.371,1.536,1.536,0,0,1,1.037.371,1.138,1.138,0,0,1,.431.892,1.139,1.139,0,0,1-.431.892A1.537,1.537,0,0,1,266-828Z",
    transform: "translate(1263 1319)",
    fill: "#2f7373"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncompleteQuestionItemIcon);
export default __webpack_public_path__ + "static/media/Incomplete Question Item Icon.3c47256775f1486e2930a1c6b9edf0ea.svg";
export { ForwardRef as ReactComponent };